import { createFileRoute, useNavigate } from '@tanstack/react-router'

import {
  pruned,
  searchTermHistorySearchSchema,
  type SearchTermHistorySearch,
} from '@/components/Ams/search'
import { SearchTermTimelinePage } from '@/components/Ams/TimelinePage'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. A search term is keyed by its ad group and its text, so both ride in the query. */
export const Route = createFileRoute('/_app/marketing/ams/history/search-term/')({
  validateSearch: searchTermHistorySearchSchema,
  component: SearchTermRoute,
})

function SearchTermRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SearchTermTimelinePage
      search={search}
      onSearchChange={(next) => void navigate(inPageSearch<SearchTermHistorySearch>(pruned, next))}
    />
  )
}
